import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import setupInspector from '@embroider/legacy-inspector-support/ember-source-4.12';
import { setConfig } from 'ember-basic-dropdown/config';
import config from 'uplisting-frontend/config/environment';
import '@glint/environment-ember-loose';
import '@glint/environment-ember-template-imports';
import 'uplisting-frontend/inflector';
import { startSentry } from 'uplisting-frontend/sentry';
import 'uplisting-frontend/font-awesome';
import '@warp-drive/ember/install';

if (config.IS_DEV) {
  import('uplisting-frontend/deprecation-workflow');
}

startSentry();

setConfig({
  rootElement: config.APP.rootElement,
});

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;

  Resolver = Resolver;

  // setup inspector for this application
  inspector = setupInspector(this);
}

loadInitializers(App, config.modulePrefix);
